import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {fetchUserFriends} from "../../creators/user.friends";

import {Button} from "./Button";
import SimpleEditor from "./editor/SimpleEditor";
import {Can} from "../../ability-context";
import CtaCannot from "./CtaCannot";
//import _ from "lodash";

class InputPost extends React.Component {

    static defaultProps = {
        emoji: false,
        sendBtnIcon: false,
        sendBtn: false,
        btnContent: "",

        placeholder: "",
        contentRaw: "",

        loading: false,
        error: false,

        handleSubmit: () => {
        },
    };

    constructor(props) {
        super(props);

        this.state = {
            focus: false,
            contentRaw: this.props.contentRaw,
        };
        this.canOptions = {
            action : "create",
            subject : {},
            modelName : "Comment",
            passThrough : true,
            ...this.props.canOptions
        };
        this.editorRef = React.createRef();

        this.handleContent = this.handleContent.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitMessageTimeout = this.handleSubmitMessageTimeout.bind(this);

        if(this.props.currentUserInitialized && this.props.currentUserId && !this.props.userFriendsInitialized){
            this.props.fetchUserFriends(this.props.currentUserId);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.currentUserId !== prevProps.currentUserId){
            this.props.fetchUserFriends(this.props.currentUserId);
        }
    }

    handleContent(value) {
        this.setState({contentRaw: value});
    }

    handleSubmit(event){
        if(event){
            event.preventDefault();
            event.stopPropagation();
        }

        setTimeout(()=>{

            if(typeof this.handleSubmitMessageTimeout === "function"){
                this.handleSubmitMessageTimeout();
            }
        },50)
    }

    handleSubmitMessageTimeout() {
        let hasText = this.editorRef.current.handleHasText();
        if(hasText){
            this.props.handleSubmit({contentRaw: this.state.contentRaw}, this.editorRef.current.hasCustomMention());
            if(this.editorRef.current){
                this.setState({contentRaw: this.editorRef.current.getRaw()});
                this.editorRef.current.handleClear();
            }

        }
    }

    onFocus = () => {
        if(typeof this.props.onFocus === "function"){
            this.props.onFocus();
        }
    };
    onBlur = () => {
        if(typeof this.props.onBlur === "function"){
            this.props.onBlur();
        }
    };

    render() {
        //console.log(this.canOptions);
        return (
            <div className="message-container row align-center px-8">
                <Can {...this.canOptions}>
                    {can=>{
                        return can ? (
                                <form className="message-input-wrapper" onSubmit={(event) => this.handleSubmit(event)}>
                                    <SimpleEditor onChange={(contentRaw) => this.setState({contentRaw})}
                                                  ref={this.editorRef}
                                                  onBlur={()=>this.onBlur()}
                                                  onFocus={()=>this.onFocus()}
                                                  handleReturn={this.props.enterSubmit ? this.handleSubmit : ""}
                                                  userFriends={this.props.userFriends}
                                                  subCommentAnswer={this.props.subCommentAnswer}
                                                  resetSubCommentAnswer={this.props.resetSubCommentAnswer}
                                                  editorStyle={this.props.editorStyle}
                                                  placeholder={this.props.placeholder}
                                                  defaultValue={this.state.contentRaw}/>
                                    {this.props.sendBtnIcon && (
                                        <Button
                                            className={"sendBtnIcon"}
                                            size={"small"}
                                            icon={"paper-plane"}
                                            loading={this.props.loading}
                                            btnType={"submit"}/>
                                    )}
                                    {this.props.sendBtn && (
                                        <Button 
                                            className={"sendBtn"}
                                            size={"medium"}
                                            btnStyle={"primary-reverse"}
                                            loading={this.props.loading}
                                            btnType={"submit"}
                                            content={this.props.btnContent}/>

                                    )}
                                    {this.props.error && (
                                        <div className={"input-error"}>{this.props.error}</div>
                                    )}
                                </form>
                            ) : (
                            <div className="message-input-wrapper" >
                                <SimpleEditor onChange={(contentRaw) => this.setState({contentRaw})}
                                              ref={this.editorRef}
                                              handleReturn={""}
                                              userFriends={this.props.userFriends}
                                              subCommentAnswer={this.props.subCommentAnswer}
                                              resetSubCommentAnswer={this.props.resetSubCommentAnswer}
                                              editorStyle={this.props.editorStyle}
                                              placeholder={this.props.placeholder}
                                              defaultValue={this.state.contentRaw}/>
                                {this.props.sendBtnIcon && (
                                    <CtaCannot action={ this.canOptions.subject === "Status" ? "createStatus" : "createComment"} isModal={true} button={{icon : "paper-plane", btnType : null, loading : this.props.loading, className : "sendBtnIcon", disabled : this.editorRef.current && !this.editorRef.current.handleHasText() }} />
                                )}
                                {this.props.sendBtn && (
                                    <CtaCannot action={ this.canOptions.subject === "Status" ? "createStatus" : "createComment"} isModal={true} button={{content : this.props.btnContent,icon : "paper-plane", btnStyle : "primary-reverse", size : "medium", btnType : null, loading : this.props.loading, className : "sendBtn", disabled : this.editorRef.current && !this.editorRef.current.handleHasText() }} />
                                )}
                            </div>
                            )}}
                </Can>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUserId: state.currentUser.data && state.currentUser.data._id,
        currentUserInitialized: state.currentUser.initialized,
        userFriends: state.userFriends.data,
        userFriendsLoading: state.userFriends.loading,
        userFriendsInitialized: state.userFriends.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserFriends,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InputPost);